import React from 'react';
import { useDispatch } from 'react-redux';
import { setFilter } from '@store/aiAlerts/summary/actions';
import Bulb from '@src/icons/insights/bulb.svg';
import { StyledTag, IconWrap } from './styled';

function FilterLabel({ filter }) {
  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(setFilter(null));
  };

  return (
    <StyledTag closable onClose={onClose} color="blue">
      <IconWrap><Bulb /></IconWrap>
      {filter.name}
    </StyledTag>
  );
}

export default FilterLabel;
